import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { Booking } from '@/types/booking.types';
import type { ReservationDrawerStatusKey } from './reservationDrawerStatus';
import { reservationStatusConfig } from './reservationDrawerStatus';

interface ReservationHeaderProps {
  booking: Booking | undefined;
  reservationId: string | null;
  statusKey: ReservationDrawerStatusKey;
  onClose: () => void;
}

export function ReservationHeader({
  booking,
  reservationId,
  statusKey,
  onClose,
}: ReservationHeaderProps) {
  const status = reservationStatusConfig[statusKey];
  const StatusIcon = status.icon;

  return (
    <div className="sticky top-0 bg-card/95 backdrop-blur-sm border-b border-border/50 p-4 z-10">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-semibold">
              Reserva #{booking?.code ?? reservationId}
            </h2>
            <span
              className={cn(
                'flex items-center gap-1 text-xs px-2 py-1 rounded-full border',
                status.color,
              )}
            >
              <StatusIcon className="w-3 h-3" />
              {status.label}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">
            {booking ? `Criada em ${new Date(booking.created_at).toLocaleDateString('pt-BR')}` : ''}
          </p>
        </div>
        <button
          onClick={onClose}
          className="p-2 rounded-lg hover:bg-muted/50 transition-colors"
          aria-label="Fechar reserva"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
